export const calendarTokens = {
  datepicker: {
    root: {
      transitionDuration: '{transition.duration}'
    },
    panel: {
      borderColor: 'transparent',
      padding: '0',
      borderRadius: '{borderRadius.md}'
    },
    header: {
      borderColor: 'transparent',
      padding: '0.5rem 1rem'
    },
    title: {
      fontWeight: '600'
    },
    dayView: {
      margin: '0'
    },
    weekDay: {
      padding: '0.5rem',
      fontWeight: '400'
    },
    group: {
      borderColor: 'transparent',
      gap: '0.5rem'
    },
    date: {
      width: '2.5rem',
      height: '2.5rem',
      padding: '0.5rem',
      borderRadius: '0',
      fontWeight: '400',
      selectedBackground: '{surface.0}',
      selectedColor: '{surface.1000}',
      rangeSelectedBackground: 'transparent',
      rangeSelectedColor: '{surface.1000}'
    },
    colorScheme: {
      light: {
        dropdown: {
          background: '{surface.0}',
          color: '{primary.color}',
          hoverBackground: '{surface.100}',
          activeBackground: '{surface.200}'
        },
        today: {
          background: '{surface.200}',
          color: '{surface.1000}'
        }
      },
      dark: {
        dropdown: {
          background: '{surface.800}',
          color: '{primary.color}',
          hoverBackground: '{surface.700}',
          activeBackground: '{surface.600}'
        },
        today: {
          background: '{surface.700}',
          color: '{surface.0}'
        }
      }
    }
  }
};

export type CalendarTokens = typeof calendarTokens;
